module.exports = __webpack_public_path__ + "static/media/announcements.07888cd7.svg";